<template>
  <v-text-field
    v-bind="$attrs"
    v-on="$listeners"
    filled
  ></v-text-field>
</template>

<script>
  export default {
    name: 'IPAdress',
  }
</script>

<style scoped>

</style>
